import {
  BookColoredIcon,
  CalendarColoredIcon,
  DollarCircleColoredIcon,
  DollarColoredIcon,
  InfoColoredIcon,
  MagnifyColoredIcon,
  MapMarkerColoredIcon,
  PercentTagColoredIcon,
  SolarEnergyColoredIcon,
  WebColoredIcon
} from 'assets';

export const CUSTOMER_SUPPORT_DEFAULT_ICONS = [
  {
    key: 'calendar',
    icon: CalendarColoredIcon,
    path: '/svg/calendar-colored.svg'
  },
  {
    key: 'dollar',
    icon: DollarColoredIcon,
    path: '/svg/dollar-colored.svg'
  },
  {
    key: 'dollar-circle',
    icon: DollarCircleColoredIcon,
    path: '/svg/dollar-circle-colored.svg'
  },
  {
    key: 'book',
    icon: BookColoredIcon,
    path: '/svg/book-colored.svg'
  },
  {
    key: 'info',
    icon: InfoColoredIcon,
    path: '/svg/info-colored.svg'
  },
  {
    key: 'magnify',
    icon: MagnifyColoredIcon,
    path: '/svg/magnify-colored.svg'
  },
  {
    key: 'map-marker',
    icon: MapMarkerColoredIcon,
    path: '/svg/map-marker-colored.svg'
  },
  {
    key: 'percent-tag',
    icon: PercentTagColoredIcon,
    path: '/svg/percent-tag-colored.svg'
  },
  {
    key: 'solar-engergy',
    icon: SolarEnergyColoredIcon,
    path: '/svg/solar-energy-colored.svg'
  },
  {
    key: 'web',
    icon: WebColoredIcon,
    path: '/svg/website-colored.svg'
  }
];
